import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Divider from 'widgets/Divider';
import { getLocaleStringForSupportLink } from 'libs/common';
import './AuthFooter.scss';

function AuthFooter(props) {
  const { i18n: { info: { locale } } } = props;
  const { intl } = props;

  return (
    <div className="Auth__AuthFooter">
      <Divider
        style={{
          backgroundColor: '#DBDADA',
          marginBottom: '15px',
          height: '1px',
          color: '#DBDADA',
          letterSpacing: '2px',
          lineHeight: '17px'
        }}
      />
      <div className="Auth__AuthFooter__Links">
        <a href={`http://www.choosemuse.com/${getLocaleStringForSupportLink(locale)}`} className="Auth__AuthFooter__LinkText" rel="noopener noreferrer" target="_blank">
          <FormattedMessage id="components.auth.authFooter.linkText.learnMore" />
        </a>
        <span className="Auth__AuthFooter__LinkDivider">|</span>
        <a href={intl.formatMessage({ id: 'components.auth.authFooter.link.privacy' })} rel="noopener noreferrer" target="_blank" className="Auth__AuthFooter__LinkText">
          <FormattedMessage id="components.auth.authFooter.linkText.privacy" />
        </a>
        <span className="Auth__AuthFooter__LinkDivider">|</span>
        <a href="https://choosemuse.com/contactsupport" className="Auth__AuthFooter__LinkText">
          <FormattedMessage id="components.auth.authFooter.linkText.contactUs" />
        </a>
      </div>
    </div>
  );
}

AuthFooter.propTypes = {
  i18n: PropTypes.object.isRequired
};

export default connect(
  ({
    i18n
  }) => ({
    i18n
  })
)(injectIntl(AuthFooter));



// WEBPACK FOOTER //
// ./src/components/Auth/AuthFooter/AuthFooter.jsx